const CATS = ['Starter','Main','Side','Dessert','Drinks','Bread'];
const COLORS = { Starter:'#C4612A', Main:'#2C1A0E', Side:'#7A6555', Dessert:'#D4A017', Drinks:'#5B7A5B', Bread:'#B0977A' };

export default function MenuBalance({ dishes }) {
  const counts = {};
  CATS.forEach(c => { counts[c] = dishes.filter(d => d.category === c && d.status === 'approved').length; });
  const total = Object.values(counts).reduce((a,b)=>a+b,0) || 1;
  const r=54, cx=70, cy=70, circ=2*Math.PI*r;
  let offset=0;
  const slices = CATS.filter(c=>counts[c]>0).map(c => {
    const dash = (counts[c]/total)*circ;
    const s = { cat:c, dash, offset, color:COLORS[c] };
    offset += dash;
    return s;
  });
  const approvedCount = dishes.filter(d=>d.status==='approved').length;

  return (
    <div style={{display:'flex',alignItems:'center',gap:20}}>
      <svg width="140" height="140" viewBox="0 0 140 140">
        {slices.length===0 && <circle cx={cx} cy={cy} r={r} fill="none" stroke="#E5D9C8" strokeWidth="18"/>}
        {slices.map((s,i) => (
          <circle key={i} cx={cx} cy={cy} r={r} fill="none" stroke={s.color} strokeWidth="18"
            strokeDasharray={`${s.dash} ${circ-s.dash}`}
            strokeDashoffset={-s.offset+circ/4}
            transform={`rotate(-90 ${cx} ${cy})`}/>
        ))}
        <text x={cx} y={cy-6} textAnchor="middle" style={{fontFamily:'Cormorant Garamond,serif',fontSize:22,fill:'#2C1A0E',fontWeight:600}}>{approvedCount}</text>
        <text x={cx} y={cy+12} textAnchor="middle" style={{fontFamily:'Jost,sans-serif',fontSize:10,fill:'#7A6555'}}>dishes</text>
      </svg>
      <div style={{flex:1}}>
        {CATS.map(c => counts[c]>0 && (
          <div key={c} style={{display:'flex',alignItems:'center',gap:8,marginBottom:6}}>
            <span style={{width:10,height:10,borderRadius:'50%',background:COLORS[c],flexShrink:0}}/>
            <span style={{fontSize:13}}>{c}</span>
            <span style={{fontSize:13,color:'#7A6555',marginLeft:'auto'}}>{counts[c]}</span>
          </div>
        ))}
        {approvedCount===0 && <p style={{fontSize:13,color:'#7A6555'}}>No approved dishes yet</p>}
      </div>
    </div>
  );
}
